import { computed, unref, type MaybeRef } from 'vue'
import type { AxiosResponse } from 'axios'
import { createQuery } from '@/queries'
import { getCapsulesPreview } from '@/features/capsules/api/capsules'
import type { Audience } from '@/features/recommendations/api/recommendations'

type HomeCapsulesPreviewResponse = Awaited<
  ReturnType<typeof getCapsulesPreview>
> extends AxiosResponse<infer T>
  ? T
  : never

export interface HomeCapsulesPreviewQueryInput {
  limit?: number
  audience: Audience
}

const DEFAULT_LIMIT = 10

export function useHomeCapsulesPreviewQuery(
  input: MaybeRef<HomeCapsulesPreviewQueryInput>,
) {
  return createQuery<HomeCapsulesPreviewResponse>({
    key: computed(() => {
      const value = unref(input)
      return [
        'home',
        'capsules-preview',
        value.limit ?? DEFAULT_LIMIT,
        value.audience,
      ] as const
    }),
    fetcher: async () => {
      const value = unref(input)
      const response = await getCapsulesPreview(
        value.limit ?? DEFAULT_LIMIT,
        value.audience,
      )
      return response.data
    },
    staleTime: 10 * 60 * 1000,
  })
}
